(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mudhunters-year-round-badge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-floating-year-round')) {
    customElements.define('mh-floating-year-round', class extends HTMLElement {
      connectedCallback() {
        this.start = () => this.mount();
        document.addEventListener('DOMContentLoaded', this.start, { once: true });
        this.mount();
      }
      mount() {
        const template = this.querySelector('template');
        if (this.badge || !template || !document.body) return;
        if (document.querySelector('[data-mh-floating-badge]')) return;
        this.storageKey = 'mudhunters-year-round-hidden';
        this.editor = this.dataset.editor === 'true';
        try {
          if (!this.editor && sessionStorage.getItem(this.storageKey) === '1') return;
        } catch (_) {}
        this.badge = template.content.firstElementChild.cloneNode(true);
        // A body-level mount avoids transforms and clipping in the header/footer.
        document.body.appendChild(this.badge);
        this.media = window.matchMedia('(max-width: 767px)');
        this.lastY = Math.max(0, window.scrollY);
        this.scrollHidden = false;
        this.closed = false;
        this.refreshCandidates = true;
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateVisibility();
          });
        };
        this.onScroll = () => {
          const y = Math.max(0, window.scrollY);
          if (y <= 32) this.scrollHidden = false;
          else if (Math.abs(y - this.lastY) >= 10) this.scrollHidden = y > this.lastY;
          if (Math.abs(y - this.lastY) >= 10 || y <= 32) this.lastY = y;
          this.schedule();
        };
        this.onClose = () => {
          this.closed = true;
          try { if (!this.editor) sessionStorage.setItem(this.storageKey, '1'); } catch (_) {}
          this.schedule();
        };
        this.badge.querySelector('button').addEventListener('click', this.onClose);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        document.addEventListener('focusin', this.schedule);
        document.addEventListener('focusout', this.schedule);
        this.observer = new MutationObserver(records => {
          const external = records.filter(record => !this.badge.contains(record.target));
          if (!external.length) return;
          if (external.some(record => record.type === 'childList' || record.attributeName === 'aria-modal')) this.refreshCandidates = true;
          this.schedule();
        });
        this.observer.observe(document.body, {
          subtree: true, childList: true, attributes: true,
          attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'aria-modal']
        });
        this.updateVisibility();
      }
      updateVisibility() {
        if (!this.badge) return;
        if (this.refreshCandidates) {
          this.candidates = [...document.querySelectorAll('dialog, [aria-modal="true"], #CybotCookiebotDialog, #shopify-pc__banner, [data-mh-badge-blocker]')];
          this.refreshCandidates = false;
        }
        const blocked = this.candidates.some(element => {
          if (!element.isConnected || element.closest('[hidden], [aria-hidden="true"]')) return false;
          if (element.tagName === 'DIALOG' && !element.open) return false;
          if (element.checkVisibility && !element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          const rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
        });
        const active = document.activeElement;
        const editing = this.media.matches && active && (active.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, select') || active.isContentEditable);
        const scrolling = this.media.matches && this.dataset.autoHide === 'true' && this.scrollHidden && !this.badge.contains(active);
        const hidden = Boolean(this.closed || blocked || editing || scrolling);
        this.badge.classList.toggle('is-hidden', hidden);
        this.badge.inert = hidden;
        this.badge.setAttribute('aria-hidden', String(hidden));
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.schedule);
        document.removeEventListener('focusin', this.schedule);
        document.removeEventListener('focusout', this.schedule);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.badge?.remove();
        this.badge = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
